import { CModelRepo as cModelRepo } from "../cmodel.repo";

export class EditSecurityDialogController {
  public security: any;
  public geographies: any;
  public sectors: any;
  public assetClasses: any;
  public saving = false;
  public fixedIncomeTypes: any;
  public currencyList = ["MUR", "EUR", "GBP", "USD", "CHF"];

  /** @ngInject */
  constructor(
    private cModelRepo: cModelRepo,
    private $mdDialog: angular.material.IDialogService
  ) {}

  $onInit(): void {
    // console.log(this.security);
  }

  saveSecurityChanges() {
    console.log(this.security);
    this.saving = true;
    this.cModelRepo
      .updateSecurityItem(this.security.id, this.security)
      .then((res) => this.$mdDialog.hide())
      .finally(() => (this.saving = false));
  }

  cancel() {
    this.$mdDialog.cancel();
  }
}

export const editSecurityDialog: angular.IComponentOptions = {
  template: require("../cmodel.securitymanagement/editSecurity.Dialog.html"),
  controller: EditSecurityDialogController,
  bindings: {
    security: "<",
    geographies: "<",
    sectors: "<",
    assetClasses: "<",
    fixedIncomeTypes: "<",
  },
};



// WEBPACK FOOTER //
// ./src/app/cmodel/cmodel.securitymanagement/editSecurity.Dialog.ts